import { ToastContainer } from 'react-toastify';

import 'react-toastify/dist/ReactToastify.css';

const MAX_TOASTS_TO_DISPLAY = 5;

export default () => (
  <ToastContainer
    position="bottom-right"
    autoClose={false}
    limit={MAX_TOASTS_TO_DISPLAY}
    style={{
      // Don't overlap the Intercom icon in the bottom right:
      right: '80px',
    }}
  />
);
